import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import NextImage from "next/image";
import { Box, Button, Heading, Text, Video, prefixUrl, useWindowSize, getCookie } from "@miro-site/core";
import { useTreatment } from "@miro-site/splitio";
import styled, { useTheme } from "styled-components";
import BoardEmbedPreview from "./BoardEmbedPreview";
import { useLocalization } from "@miro-site/localization";
var MediaContainer = styled(Box).withConfig({
    componentId: "sc-60911ec8-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        borderRadius: 8,
        overflow: "hidden",
        "& iframe": {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            border: "none"
        }
    });
});
var PageHeader = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var embedBoardKey = _param.embedBoardKey, metadataId = _param.metadataId, image = _param.image, headline = _param.headline, description = _param.description, wistiaVideoId = _param.wistiaVideoId, onUseTemplateClick = _param.onUseTemplateClick, templateActions = _param.templateActions, paidTemplateDescription = _param.paidTemplateDescription, props = _object_without_properties(_param, [
        "embedBoardKey",
        "metadataId",
        "image",
        "headline",
        "description",
        "wistiaVideoId",
        "onUseTemplateClick",
        "templateActions",
        "paidTemplateDescription"
    ]);
    var theme = useTheme();
    var _$ref = useWindowSize(), _width = _$ref.width, width = _width === void 0 ? 0 : _width;
    var isMobile = width < theme.breakpoints.small;
    var currentLocale = useLocalization().currentLocale;
    var _$ref1 = _sliced_to_array(useTreatment("WCORE-46_Website_Templates_Embed_AB", {
        locale: currentLocale,
        is_mobile: isMobile,
        is_desktop: !isMobile,
        is_bot: false,
        prospect_user: !getCookie("ajs_user_id")
    }), 1), withEmbeds = _$ref1[0];
    var mediaContent = /*#__PURE__*/ _jsx(NextImage, {
        src: prefixUrl(image.original.webp || ""),
        unoptimized: true,
        alt: image.name,
        priority: true,
        width: 720,
        height: 480
    });
    if (wistiaVideoId) {
        mediaContent = /*#__PURE__*/ _jsx(Video, {
            id: wistiaVideoId
        });
    }
    if (withEmbeds === "on") {
        mediaContent = /*#__PURE__*/ _jsx(BoardEmbedPreview, {
            boardKey: embedBoardKey,
            imageSrc: prefixUrl(image.original.webp || ""),
            imageName: image.name
        });
    }
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        ref: ref,
        "data-track-place": "template-page-header",
        $pb: [
            20,
            28,
            28,
            28
        ],
        $styles: {
            display: [
                undefined,
                "flex",
                "flex",
                "flex"
            ],
            flexWrap: [
                undefined,
                "nowrap",
                "nowrap",
                "nowrap"
            ],
            flexDirection: [
                undefined,
                "row-reverse",
                "row-reverse",
                "row-reverse"
            ]
        }
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                $mb: [
                    40,
                    null,
                    null,
                    null
                ],
                $styles: {
                    position: "relative",
                    borderRadius: 8,
                    width: [
                        325,
                        720,
                        720,
                        720
                    ],
                    height: wistiaVideoId ? undefined : [
                        216,
                        480,
                        480,
                        480
                    ]
                },
                children: /*#__PURE__*/ _jsx(MediaContainer, {
                    children: mediaContent
                })
            }),
            /*#__PURE__*/ _jsxs(Box, {
                $styles: {
                    textAlign: [
                        "center",
                        "left",
                        "left",
                        "left"
                    ],
                    width: [
                        "100%",
                        360,
                        360,
                        360
                    ]
                },
                $mr: [
                    null,
                    40,
                    40,
                    40
                ],
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        as: "h1",
                        $variant: "h2",
                        $mb: [
                            20,
                            24,
                            24,
                            24
                        ],
                        children: headline
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        $variant: "p1",
                        $transparency: 0.3,
                        $mb: 40,
                        children: description
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        "data-track-id": "use-template",
                        "data-template-id": metadataId,
                        $buttonType: "primary",
                        $size: "medium",
                        $withArrow: true,
                        onClick: onUseTemplateClick,
                        $mb: [
                            12,
                            15
                        ],
                        children: templateActions.USE_TEMPLATE
                    }),
                    paidTemplateDescription ? /*#__PURE__*/ _jsx(Text, {
                        $variant: "p2",
                        $styles: {
                            color: theme.templates.colors.secondary60
                        },
                        children: paidTemplateDescription
                    }) : null
                ]
            })
        ]
    }));
});
PageHeader.displayName = "PageHeader";
export default PageHeader;
